module.exports = __webpack_public_path__ + "static/media/H2.794179ca.png";